<template>
  <div class="login-container" v-loading="loading">

    <div class="logo-text df aic jcsb">
      <img src="../../assets/images/login-logo.png" class="login-logo cup"
        @click="$navigate('/index/index', null, false)" alt="">

      <el-select v-model="langActive" placeholder="请选择" @change="changeLanguage">
        <el-option v-for="item in datalist.lang" :key="item.tws_name" :label="item.tws_name" :value="item.twss_lang">
        </el-option>
      </el-select>
    </div>

    <template v-if="language == 'zh'">
      <img :src="require('../../assets/images/logintext-zh.png')" class="login-textimg" alt="">
    </template>
    <template v-if="language == 'en'">
      <img :src="require('../../assets/images/logintext-en.png')" class="login-textimg" alt="">
    </template>


    <!-- 账号登录/注册 -->
    <loginRegist :formdata="accountForm" @handlePasswordLogin="handlePasswordLogin" @handleLogin="handleLogin"
      v-if="logintype == 1" />

    <!-- 密码登录 -->
    <PwdLogin :formdata="pwdForm" @handleCodeLogin="handlePasswordLogin" @handleLogin="handleLogin"
      v-else-if="logintype == 2" />

    <!-- 验证码登录 -->
    <CodeLogin :formdata="accountForm" @handlePasswordLogin="handlePasswordLogin" @handleLogin="handleLogin"
      v-else-if="logintype == 3" />


  </div>
</template>

<script>
import Cookies from 'js-cookie';
import { mapGetters, mapActions } from 'vuex';
import loginRegist from './components/loginRegist.vue'
import PwdLogin from './components/PwdLogin.vue'
import CodeLogin from './components/CodeLogin.vue'
import {
  loginNew,
} from "@api/user";
export default {
  components: {
    loginRegist,
    PwdLogin,
    CodeLogin
  },
  data() {
    return {

      // 当前语言

      langActive: 'zh',

      logintype: 1,  //1:账号登录/注册 2:密码登录 3:验证码登录

      loading: false,  //loading

      // 账号登录/注册   ---- 1  3
      accountForm: {
        phoneEmail: "phone", //选择手机还是邮箱
        code_phone: "",
        user_mobile_area_code: "86", //手机区号
        phone: "", //手机号
        email: "", //邮箱
        code: "", //验证码
        code_email: "", //验证码-邮箱
        privacy: true, //隐私声明  
      },

      // 密码登录   ---- 2
      pwdForm: {
        // 账号
        account: "",
        // 密码
        password: "",
        // 隐私声明
        privacy: false,
      },
      // 获取当前语言
      language: this.$i18n.locale,
      callback: '',

    };
  },
  computed: {
    // ...mapGetters() // 使用命名空间访问 home 模块的 datalist getter
    ...mapGetters('home', ['datalist'])

  },
  beforeDestroy() {
    window.removeEventListener('popstate', this.handlePopState);
  },
  // 获取地址栏参数
  mounted() {
    window.addEventListener('popstate', this.handlePopState);

    this.langActive = localStorage.getItem('currentLanguage');
    const logintype = this.$route.params.logintype;
    const loginTab = this.$route.params.loginTab;
    if (logintype) {
      this.logintype = logintype
    }


    // 获取loginTab
    if (loginTab) {
      this.accountForm.phoneEmail = loginTab;
    }

    //20250924修改前
    // const queryString = window.location.search;
    // const urlParams = new URLSearchParams(queryString);
    // this.callback = urlParams.get("callback");


    //20250924修改后
    // 获取完整查询字符串（不含?）
    const query = window.location.search.slice(1);
    // 匹配callback=开始到字符串结束的所有内容
    const callbackMatch = query.match(/callback=(.*)/);

    if (callbackMatch && callbackMatch[1]) {
      // 解码并赋值
      this.callback = decodeURIComponent(callbackMatch[1]);
      // 输出：/cn/rafflelandingpage?tre_ep=6be031294c277&trer_source_type=40&trer_source_id=1545
    }else{
      this.callback='';
    }

    this.fetchDatalist(); // 调用 action 加载数据列表

  },
  methods: {
    ...mapActions('home', ['fetchDatalist']), // 使用命名空间访问 home 模块的 actions
    handlePopState(event) {
      // 阻止默认行为，但不阻止前进或后退
      event.preventDefault();
      // 可以在这里添加其他逻辑，例如重新加载当前页面或显示警告等
      window.location.reload(); // 重新加载当前页面
    },

    getCallbackFromUrl(url) {
      const urlObj = new URL(url);
      const callback = urlObj.searchParams.get('callback');
      return callback;
    },

    // 切换语言
    changeLanguage(data) {
      // window.location.pathname;
      // window.location.href.replace(window.location.origin, '');
      // console.log(history,"...................");

      // return false;

      let callback = this.getCallbackFromUrl(window.location.href);

      const currentUrl = window.location.pathname;
      let newUrl = "";
      if (data == 'en') {
        let pattern = /\/cn\//;
        let replacement = "/en/";
        newUrl = currentUrl.replace(pattern, replacement);

        // callback=callback.replace('/cn/','/en/');
        callback = '/en/index/index';
        Cookies.set('siteData', '{"tws_id":2,"apply_site":"protal_en"}');
      } else {
        let pattern = /\/en\//;
        let replacement = "/cn/";
        newUrl = currentUrl.replace(pattern, replacement);
        // callback=callback.replace('/en/','/cn/');
        callback = '/cn/index/index';
        Cookies.set('siteData', '{"tws_id":1,"apply_site":"protal"}');
      }
      localStorage.setItem('currentLanguage', data);
      this.$i18n.locale = data;
      setTimeout(() => {
        this.$forceUpdate();
        // 设置 url 参数 callback
        if (callback) {
          newUrl = newUrl + '?callback=' + callback;
        }
        // window.location.href = newUrl;
        try {
          window.close();
          console.log("Closing the window is not allowed in some browsers.")
        } catch (e) {
          // console.warn('Closing the window is not allowed in some browsers.');
        }
        // 打开新窗口
        window.open(newUrl, '_blank');
        // 关闭当前窗口


      }, 20);

    },

    handlePasswordLogin(type) {
      // 跳转页面
      this.$navigate('/login/' + type + '?callback=' + this.callback, null, false);
      // loading 显示
      this.loading = true;
    },

    // 登录
    async handleLogin(formdata) {
      if (!formdata.privacy) {
        this.$message.error(this.$t("请勾选隐私声明"));
        return;
      }
      if (formdata.is_pwd_login == undefined || formdata.is_pwd_login != 1) {
        if (formdata.phoneEmail == 'phone') {
          formdata.code = formdata.code_phone;
          formdata.user_account = formdata.phone;
          formdata.register_type = 1;
        } else {
          formdata.code = formdata.code_email;
          formdata.user_account = formdata.email;
          formdata.register_type = 2;
        }
      }
      let loginRes = await loginNew(formdata);

      if (loginRes.status != 200) {
        return false;
      }
      // 资料未完善，取到完善资料页
      if (loginRes.data.is_edit == 2) {
        return this.$navigate('/information?callback=' + this.callback, null, false);
      }
      if (this.callback == null || this.callback == undefined || this.callback == 'null') {
        return this.$navigate('/index/index', null, false);
      } else {
        return window.location.href = this.callback;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.logo-text {
  padding: 40px;
}


.login-textimg {
  width: 44.43%;
  position: absolute;
  left: 120px;
  top: 30%;
}

* {
  font-family: "harmonyos";
  font-weight: 400;
}

::v-deep() {
  .el-radio__inner {
    width: 20px;
    height: 20px;
    border: 2px solid rgb(183, 37, 30) !important;
  }

}

.login-button {
  .el-button--primary {
    width: 100%;
    height: 40px;
    line-height: 40px;
    border-radius: 20px;
    padding: 0;
    background: rgb(183, 37, 30);
    color: rgb(255, 255, 255);
    font-size: 16px;
  }
}

.phone-input {
  .phone-input-item {
    height: 60px;
    border-radius: 8px;
    background: rgb(245, 248, 255);
    padding: 10px 16px;
    margin-top: 24px;

    ::v-deep() {
      .el-input--suffix .el-input__inner {
        border: none;
        background: transparent;
        padding-right: 0;

        color: rgb(179, 179, 179);

        font-size: 14px;

      }

      .el-input__inner {
        padding: 0;
        border: none;
        background: transparent;

        &::placeholder {
          color: rgb(179, 179, 179);
          font-size: 14px;
        }
      }

      .el-input__suffix {
        display: none;
      }
    }
  }
}

.password-login {
  margin-top: 24px;

  ::v-deep() {
    .el-button {
      color: rgb(183, 37, 30);
      font-size: 16px;
      margin-top: 24px;
      padding: 0;
      margin: 0;
    }
  }
}

.code-input {
  width: 400px;
  height: 60px;
  padding: 10px 16px 10px 16px;
  border-radius: 4px;
  background: rgb(245, 248, 255);
  margin-top: 24px;

  ::v-deep() {
    .el-input__inner {
      border: none;
      background: transparent;
      padding: 0;

      &::placeholder {
        color: rgb(179, 179, 179);
        font-size: 14px;
      }
    }

    .el-button {
      border: none;
      background: transparent;
      padding: 0;
      margin: 0;
      color: rgb(183, 37, 30);
      font-size: 14px;
    }
  }
}

.login-container {
  width: 100%;
  height: 100%;
  background: url("../../assets/images/login-bg.png") no-repeat left bottom;
  background-size: cover;
  position: relative;

  .login-content {
    width: 520px;
    height: 600px;
    min-height: 500px;
    max-height: 100vh;
    border-radius: 16px;
    box-shadow: 0px 8px 24px 8px rgba(28, 57, 123, 0.08);
    background: rgb(255, 255, 255);
    padding: 80px 60px;
    position: absolute;
    right: 120px;
    top: 50%;
    transform: translateY(-50%);
  }

  .title {
    font-size: 20px;
    line-height: 30px;
    color: rgb(25, 25, 25);

    span {
      font-size: 20px;
      line-height: 30px;


      position: relative;
    }

    span.active::after {
      content: "";
      display: inline-block;
      width: 100%;
      height: 2px;
      background: #b7251e;
      position: absolute;
      bottom: 0;
      left: 0;
    }
  }
}
</style>